/* ============================================================
   LEVEL RENOVATION — Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Topbar + Header scroll state ── */
  const topbar = document.getElementById('topbar');
  const header = document.querySelector('.header');
  if (header) {
    const isTransparentPage = header.classList.contains('header--transparent');
    const onScroll = () => {
      if (window.scrollY > 60) {
        header.classList.add('header--scrolled');
        header.classList.remove('header--transparent');
        if (topbar) topbar.classList.add('is-hidden');
      } else {
        header.classList.remove('header--scrolled');
        if (isTransparentPage) header.classList.add('header--transparent');
        if (topbar) topbar.classList.remove('is-hidden');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Desktop dropdown click-toggle ── */
  document.querySelectorAll('.nav__item--has-dropdown').forEach(item => {
    const trigger = item.querySelector('.nav__link--dropdown');
    if (!trigger) return;
    trigger.addEventListener('click', (e) => {
      const isOpen = item.classList.contains('is-open');
      // close all dropdowns
      document.querySelectorAll('.nav__item--has-dropdown.is-open').forEach(d => {
        d.classList.remove('is-open');
        const a = d.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        e.preventDefault();
      }
    });
  });

  // Close desktop dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav__item--has-dropdown')) {
      document.querySelectorAll('.nav__item--has-dropdown.is-open').forEach(d => {
        d.classList.remove('is-open');
        const a = d.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Mobile nav toggle ── */
  const navToggle  = document.querySelector('.nav__toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.getElementById('mobileNavClose');

  const closeMobileNav = () => {
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileNav.setAttribute('aria-hidden', 'true');
  };

  const openMobileNav = () => {
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileNav.setAttribute('aria-hidden', 'false');
  };

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      if (mobileNav.classList.contains('is-open')) { closeMobileNav(); } else { openMobileNav(); }
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileNav);
  }

  /* ── Mobile nav sub-menus ── */
  document.querySelectorAll('[data-toggle]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(btn.dataset.toggle);
      if (!target) return;
      const isOpen = target.classList.contains('is-open');
      target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const inner  = item.querySelector('.faq-answer-inner');
      const isOpen = item.classList.contains('is-open');

      // close all
      document.querySelectorAll('.faq-item.is-open').forEach(openItem => {
        openItem.classList.remove('is-open');
        openItem.querySelector('.faq-answer').style.maxHeight = '0';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  /* ── Scroll reveal ── */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  /* ── Counter animation ── */
  function animateCounter(el) {
    const target = parseInt(el.dataset.target, 10);
    const suffix = el.dataset.suffix || '';
    const duration = 2000;
    const step = target / (duration / 16);
    let current = 0;
    const timer = setInterval(() => {
      current = Math.min(current + step, target);
      el.textContent = Math.floor(current).toLocaleString('it-IT') + suffix;
      if (current >= target) clearInterval(timer);
    }, 16);
  }

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-target]').forEach(el => counterObserver.observe(el));

  /* ── Sticky CTA bar ── */
  const stickyCta = document.querySelector('.sticky-cta');
  if (stickyCta) {
    const showAfter = 600;
    window.addEventListener('scroll', () => {
      if (window.scrollY > showAfter) {
        stickyCta.classList.add('is-visible');
      } else {
        stickyCta.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  /* ── Form submission ── */
  document.querySelectorAll('.contact-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Invio in corso...';
      btn.disabled = true;

      // Simulate sending (replace with actual endpoint)
      await new Promise(resolve => setTimeout(resolve, 1500));

      btn.innerHTML = '✓ Richiesta inviata!';
      btn.style.background = '#22C55E';
      btn.style.color = '#fff';

      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.style.background = '';
        btn.style.color = '';
        form.reset();
      }, 3000);
    });
  });

  /* ── Smooth scroll anchors ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 76;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset - 16,
          behavior: 'smooth'
        });
      }
    });
  });

  /* ── Spin CSS for form button ── */
  const style = document.createElement('style');
  style.textContent = `.spin { animation: spin 1s linear infinite; } @keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(style);

})();
